import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface LanguageState {
    language: 'english' | 'marathi';
}

const storedLanguage = localStorage.getItem("language") as 'english' | 'marathi' | null;
const initialState: LanguageState = {
    language: storedLanguage || 'marathi',
};

const languageSlice = createSlice({
    name: 'language',
    initialState,
    reducers: {
        setLanguage: (state, action: PayloadAction<'english' | 'marathi'>) => {
            state.language = action.payload;
            localStorage.setItem("language", action.payload);
        },
    },
});

export const { setLanguage } = languageSlice.actions;
export default languageSlice.reducer;
